import { InjectionToken } from '../../injection';

import { IApiEndpointInformation } from '../interfaces/api-endpoint-information.interface';
import { ParameterValueType } from '../interfaces/dictionary.interface';
import { MobizServerApi } from '../other/mobiz-server-api.enum';

/** The string templating service interface. */
export interface IServerApiBuilderService {
  /**
   * Default values for IApiEndpointInformation.
   */
  readonly DEFAULT_API_ENDPOINT_INFORMATION: Required<IApiEndpointInformation>;

  /**
   * Generated the full api url, including parameters.
   * @param serverApi Server api endpoint.
   * @param urlParameters Property bag with parameters that will get embedded in the api endpoint.
   * @param queryParameters Property bag with parameters that will be added in the query string part of the api endpoint.
   */
  getUrl<A extends string = MobizServerApi>(
    serverApi: A,
    urlParameters?: Record<string, ParameterValueType>,
    queryParameters?: Record<string, ParameterValueType>,
  ): string;

  /**
   * Generates the base api url.
   * @param serverApi Server api endpoint.
   * @param urlParameters Property bag with parameters that will get embedded in the api endpoint.
   * @param includeApiVersion Flag used to specify if we want to append the api version to the url.
   *
   * @deprecated will be made private, use IServerApiBuilderService.getUrl().
   */
  getBaseUrl<A extends string = MobizServerApi>(
    serverApi: A,
    urlParameters?: Record<string, ParameterValueType>,
    includeApiVersion?: boolean,
  ): string;

  /**
   * Builds query string parameters.
   * @param queryParameters Property bag with parameters that will be added in the query string part of the api endpoint.
   *
   * @deprecated will be made private, use IServerApiBuilderService.getUrl().
   */
  buildParamQueryString(queryParameters: Record<string, ParameterValueType>): string;

  /**
   * Returns the IApiEndpointInformation for a given endpoint.
   */
  getApiEndpointInformation<A extends string = MobizServerApi>(endpoint: A): Required<IApiEndpointInformation>;
}

export const IServerApiBuilderService = new InjectionToken('IServerApiBuilderService');
